export enum SearchCityDatesAdultsModeEnum {
  DEFAULT = 'DEFAULT',
  HOUSE_SEARCH = 'HOUSE_SEARCH',
}
